import { Button, SelectLabel } from '@weezevent/nacre';
import { React, useCallback, observer, useTranslation, main } from '../..';
import cssAttendee from '../../../../attendee/add-attendee/styles.module.css';
import RatesSelect from './RatesSelect';
import SessionsSelect from './SessionsSelect';
import { getLanguageOptions } from '../../../../../nacre/components/LanguageSelector';

const OrderStep = observer(() => {
    const { t, i18n } = useTranslation();
    const { hasSelection, useSessions, event, language } = main;
    const { hasSelectedSessions } = main;
    const languagesOptions = React.useMemo(
        () =>
            getLanguageOptions()
                .filter(option => event?.languages.map(l => (l === 'it' ? 'it-it' : l)).includes(option.value.toLowerCase()))
                .map(option => {
                    option.value = option.value.toLowerCase();
                    return option;
                }),
        [event]
    );

    const handleContinue = useCallback(() => {
        return main.setNextStep(1);
    }, [main]);

    const onChangeLanguage = useCallback(
        newLang => {
            main.setLanguage(newLang);
            i18n.loadLanguages([...i18n.languages, newLang]); // add the language to the loaded ones so that t() has the translations
        },
        [main, i18n]
    );

    return (
        <>
            {useSessions && <SessionsSelect />}
            {(!useSessions || (useSessions && hasSelectedSessions)) && <RatesSelect />}
            <div className={cssAttendee['select-labels-group']}>
                <SelectLabel
                    key="language_selector"
                    label={t('attendees.invitations.language')}
                    onChange={e => onChangeLanguage(e)}
                    options={languagesOptions}
                    placeholder={t('ticket.common.language')}
                    value={language}
                    useNew
                />
            </div>
            <Button primary disabled={!hasSelection} label={t('ticket.common.action.continue')} onClick={handleContinue} />
        </>
    );
});
export default OrderStep;
